import React from "react"
import classNames from "utils/classNames"

const DemandFormRow = ({
  label,
  className = undefined,
  helperText = undefined,
  details = undefined,
  children = undefined,
}) => {
  return (
    <>
      <div className={classNames("grid grid-cols-12 gap-4", className)}>
        <div className="col-span-3">
          <p className="text-gray-800 font-600 mb-0 text-base">{label}</p>
          <p className="text-gray-600">{helperText}</p>
          {details}
        </div>
        <div className="col-span-9">{children}</div>
      </div>
      <hr className="vt-demand-row-divider" />
    </>
  )
}

export default DemandFormRow
